/**
 * Sidebar Icon
 *
 */

export default function email(props = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.75 4.5H2.25C1.42157 4.5 0.75 5.17157 0.75 6V18C0.75 18.8284 1.42157 19.5 2.25 19.5H21.75C22.5784 19.5 23.25 18.8284 23.25 18V6C23.25 5.17157 22.5784 4.5 21.75 4.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.687 9.97498L19.5 13.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.313 9.97498L4.5 13.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8801 5.01398L13.3671 11.574C12.9652 11.8514 12.4885 12 12.0001 12C11.5118 12 11.035 11.8514 10.6331 11.574L1.12012 5.01398"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
